module.exports = __webpack_public_path__ + "webStatic/img/warranty_bg.b10cb7df.png";